import { Injectable } from '@angular/core';
import { UIService } from 't4core';
import { SendMessageDialog } from '../../apps/messages/dialogs/SendMessageDialog/SendMessageDialog';

@Injectable()
export class DialogService {
  private m = [{
    Key: "Test",
    Dialog: SendMessageDialog
  }];

    constructor(private ui: UIService) { }
   
  public showServiceRequest(id: string) {
    this.ui.openDialog("T4.Service.ServiceDialog", { data: { requestId: id } });
        //this.dialog.open(T4_ServiceDialog, { data: { requestId: id } });
    }

  public sendMessage() {
    //this.ui.applySettings({ dialogs: [{ key: "T4.Messaging.SendMessage", dialog: SendMessageDialog }] });
    this.ui.openDialog("T4.Messaging.SendMessage", {});
    }
}
